import React, {useState} from "react";
import axios from "axios";
import "./ContactUs.css";

const CONTACT_INFO = [
  {icon: "📧", label: "variantexclusive@gmail.com"},
  {icon: "📱", label: "+91 98257 34352"},
  {icon: "🌐", label: "variantexclusive.com"},
];

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSub] = useState(false);

  function set(key, val) {
    setForm((f) => ({...f, [key]: val}));
    setErrors((e) => ({...e, [key]: ""}));
  }

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = "Required";
    if (!form.email.includes("@")) e.email = "Valid email required";
    if (!/^[6-9]\d{9}$/.test(form.phone))
      e.phone = "Valid 10-digit number required";
    if (!form.city.trim()) e.city = "Required";
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setSub(true);
    try {
      await axios.post("/api/contact", form);
      setSubmitted(true);
    } catch (err) {
      alert(err?.response?.data?.message || "Failed. Please try again.");
    } finally {
      setSub(false);
    }
  }

  if (submitted) {
    return (
      <div className="contact-success">
        <div className="contact-success-icon">✅</div>
        <h2>Message Received!</h2>
        <p>We'll get back to you within 24 hours.</p>
        <button
          onClick={() => {
            setSubmitted(false);
            setForm({name: "", email: "", phone: "", city: "", message: ""});
          }}
        >
          Send another message
        </button>
      </div>
    );
  }

  const field = (key, label, opts = {}) => (
    <div className="contact-field">
      <label>{label} *</label>
      <input
        type={opts.type || "text"}
        value={form[key]}
        onChange={(e) => set(key, e.target.value)}
        placeholder={opts.placeholder}
        maxLength={opts.maxLength}
        className={errors[key] ? "error" : ""}
      />
      {errors[key] && <span className="contact-field-error">{errors[key]}</span>}
    </div>
  );

  return (
    <div className="contact-page">
      <div>
        <p className="contact-intro-eyebrow">Get in Touch</p>
        <h1 className="contact-title">Contact Us</h1>
        <p className="contact-sub">
          Have a question about an order, a custom piece, or anything else?
          We'd love to hear from you — our team replies within 24 hours.
        </p>

        <div className="contact-info-list">
          {CONTACT_INFO.map(({icon, label}) => (
            <div className="contact-info-row" key={label}>
              <span className="contact-info-icon">{icon}</span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="contact-card">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-form-row">
            {field("name", "Full Name", {placeholder: "Enter your name"})}
            {field("city", "City", {placeholder: "Enter your city"})}
          </div>

          {field("email", "Email Address", {
            type: "email",
            placeholder: "Enter your email",
          })}
          {field("phone", "Phone Number", {maxLength: 10})}

          <div className="contact-field">
            <label>
              Message <span className="optional">(optional)</span>
            </label>
            <textarea
              value={form.message}
              onChange={(e) => set("message", e.target.value)}
              placeholder="Tell us how we can help…"
              rows={4}
            />
          </div>

          <button type="submit" className="contact-submit" disabled={submitting}>
            {submitting ? "Sending…" : "Send Message →"}
          </button>
        </form>
      </div>
    </div>
  );
}
